import { render, staticRenderFns } from "./OnConstruction.vue?vue&type=template&id=744acbd2&scoped=true"
import script from "./OnConstruction.vue?vue&type=script&lang=js"
export * from "./OnConstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744acbd2",
  null
  
)

export default component.exports